import React, { useState } from "react"
import { Avatar as AntdAvatar } from "antd"
import Spinner from "../../components/common/Spinner"

function getAvatarAlt(fullName) {
  if (!fullName) return ""
  const nameParts = fullName?.split(" ")
  const firstName = nameParts[0]
  const lastName = nameParts[1]
  const avatarAlt = firstName?.charAt(0)?.toUpperCase() + (lastName ? lastName?.charAt(0)?.toUpperCase() : "")
  return avatarAlt
}

export const Avatar = ({ src, fullName, ...rest }) => {
  const [loading, setLoading] = useState(!!src)
  const [error, setError] = useState(false)

  // Custom image loader for AntdAvatar
  const customImg =
    src && !error ? (
      <img
        src={src}
        alt={fullName}
        style={loading ? { display: "none" } : {}}
        onLoad={() => setLoading(false)}
        onError={() => {
          setLoading(false)
          setError(true)
        }}
      />
    ) : null

  return (
    <span style={{ position: "relative", display: "inline-block" }}>
      {loading && src && !error && (
        <span style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2 }}>
          <Spinner size="default" />
        </span>
      )}
      <AntdAvatar src={customImg} {...rest}>
        {getAvatarAlt(fullName)}
      </AntdAvatar>
    </span>
  )
}
